import { render, staticRenderFns } from "./order_sent.vue?vue&type=template&id=613bc01c&scoped=true"
import script from "./order_sent.vue?vue&type=script&lang=js"
export * from "./order_sent.vue?vue&type=script&lang=js"
import style0 from "./order_sent.vue?vue&type=style&index=0&id=613bc01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bc01c",
  null
  
)

export default component.exports